// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WrapperContentCoWork__container-be02d1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 432px;
  max-height: 528px;
  background-color: var(--addition-70);
  border: 1px solid var(--base-20);
  border-radius: 32px;
  position: relative;
}

@media (max-width: 428px) {
  .WrapperContentCoWork__container-be02d1 {
    max-width: none;
    border-radius: 0;
    padding: 32px 16px;
    flex-grow: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/Pages/Components/WrapperContentCoWork/WrapperContentCoWork.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,YAAA;EACF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  box-sizing: border-box;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  max-width: 432px;\n  max-height: 528px;\n  background-color: var(--addition-70);\n  border: 1px solid var(--base-20);\n  border-radius: 32px;\n  position: relative;\n}\n\n@media (max-width: 428px) {\n  .container {\n    max-width: none;\n    border-radius: 0;\n    padding: 32px 16px;\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WrapperContentCoWork__container-be02d1`
};
module.exports = ___CSS_LOADER_EXPORT___;
